import {
  Component,
  inject,
  computed,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Location } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs';
import { LoginLayoutComponent } from './login/login-layout.component';
import { AuthStore, OAuthStore } from '@core/auth';
import { LOCAL_SALVAGE_BID_PATH } from '../features/local-salvage-bid/models/local-salvage-offer.model';

const PUBLIC_PATH_PREFIXES = [`/${LOCAL_SALVAGE_BID_PATH}/`];

@Component({
  selector: 'app-root-layout',
  standalone: true,
  imports: [LoginLayoutComponent, RouterOutlet],
  template: `
    <div class="root-layout app-content">
      @if (showLoginLayout()) {
        <app-login-layout />
      } @else {
        <router-outlet />
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .root-layout {
        width: 100vw;
        height: 100dvh;
      }

      .app-content {
        background: var(--md-sys-color-surface);
      }
    `,
  ],
})
export class RootLayoutComponent {
  private readonly authStore = inject(AuthStore);
  private readonly oauthStore = inject(OAuthStore);

  private readonly currentUrl = toSignal(
    inject(Router).events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => e.urlAfterRedirects)
    ),
    { initialValue: inject(Location).path() }
  );

  private readonly isPublicPage = computed(() =>
    PUBLIC_PATH_PREFIXES.some((prefix) => this.currentUrl().startsWith(prefix))
  );

  showLoginLayout = computed(
    () =>
      !this.isPublicPage() &&
      !this.authStore.isAuthenticated() &&
      !this.oauthStore.isOAuthCallback()
  );
}
